import React, { useCallback, useEffect } from 'react';
import { DotButton, useDotButton } from './EmblaCarouselDotButton';
import './css/embla.css';

import {
  PrevButton,
  NextButton,
  usePrevNextButtons
} from './EmblaCarouselArrowButtons'
import useEmblaCarousel from 'embla-carousel-react'

const EmblaCarouselIframes = ({htmls, options, framesRef, onIframeBlur, width, height, setCurrentSlide}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const logSlidesInView = useCallback((emblaApi) => {
    if (emblaApi.slidesInView().length == 1) {
      setCurrentSlide(emblaApi.slidesInView()[0])
    }
  }, [])

  useEffect(() => {
    if (emblaApi) emblaApi.on('slidesInView', logSlidesInView)
  }, [emblaApi, logSlidesInView])

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi)

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextButtons(emblaApi)

  return (
    <section className="embla embla-iframes" >
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {htmls.map((html, index) => (
            <div className="embla__slide" key={index}>
              {
                <div className="embla__slide__number">
                  <iframe
                      ref={el => framesRef.current[index] = el}
                      srcDoc={html}
                      style={{ 
                          width,
                          height,
                          border: 0
                      }}
                      onBlur={() => {
                        onIframeBlur(index)
                      }}
                  />
                </div>
              }
            </div>
          ))}
        </div>
      </div>

      {htmls?.length > 1 && (
        <div className="embla__controls">
          <div className="embla__buttons">
            <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
            <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
          </div>

          {/* <div className="embla__dots">
            {scrollSnaps.map((_, index) => (
              <DotButton
                key={index}
                onClick={() => onDotButtonClick(index)}
                className={'embla__dot'.concat(
                  index === selectedIndex ? ' embla__dot--selected' : ''
                )}
              />
            ))}
          </div> */}
        </div>
      )}
    </section>
  )
}

export default EmblaCarouselIframes
